export class TextAnimation {
  static async typeWord(sentence: string, eltRef, delay = 50) {
    const letters = sentence.split('');
    let i = 0;
    while (i < letters.length) {
      await this.waitForMs(delay);
      eltRef.append(letters[i]);
      i++;
    }
    return;
  }

  static async deleteWord(eltRef) {
    const word = eltRef.innerHTML;
    const letters = word.split('');
    let i = 0;
    while (letters.length > 0) {
      await this.waitForMs(50);
      letters.pop();
      eltRef.innerHTML = letters.join('');
    }
  }

  static async startAnimation(wordsList, eltRef) {
    var i = 0;
    while (true) {
      await this.typeWord(wordsList[i].innerHTML, eltRef);
      await this.waitForMs(1500);
      await this.deleteWord(eltRef);
      await this.waitForMs(500);
      i++;
      if (i >= wordsList.length) {
        i = 0;
      }
    }
  }

  private static waitForMs(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
